import { createContext, useContext } from 'react';

export interface AccordionItemContextType {
  buttonID: string;
  isExpanded: boolean;
  panelID: string;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccordionItemContext = createContext<AccordionItemContextType | null>(null);

export function useAccordionItemContext(componentName: string) {
  const context = useContext(AccordionItemContext);

  if (!context) {
    throw new Error(`<${componentName}> may be used only in the context of an <AccordionItem> component.`);
  }

  return context;
}
